export const charge = {
  name: 'chargeMain',
  path: '/chargeMain',
  component: () => import('@/views_mobile/member/charge'),
  redirect: {
    name: 'charge'
  },
  meta: {
    layout: 'default',
    text: 'charge',
    gnb: false,
    gnbMenu: 'charge'
  },
  children: [
    {
      name: 'charge',
      path: '/charge',
      component: () => import('@/views_mobile/member/charge/charge'),
      meta: {
        layout: 'default',
        text: '충전',
        gnb: false,
        gnbMenu: 'charge'
      }
    },
    {
      name: 'coinCharge',
      path: '/coinCharge',
      props: true,
      component: () => import('@/views_mobile/member/charge/coinCharge'),
      meta: {
        layout: 'default',
        text: '충전',
        gnb: false,
        gnbMenu: 'charge'
      }
    }
  ]
}
